import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl, FormattedMessage, defineMessages} from 'react-intl';

const I18N = defineMessages({
  TOTAL: {
    id: 'agGrid.total',
    defaultMessage: 'Total',
    description: 'label for total label formatter',
  },
});

const TotalLabelFormatter = () => <FormattedMessage {...I18N.TOTAL} />;

TotalLabelFormatter.displayName = 'TotalLabelFormatter';

TotalLabelFormatter.propTypes = {
  value: PropTypes.string,
};

TotalLabelFormatter.defaultProps = {
  value: undefined,
};

export default injectIntl(TotalLabelFormatter);
